import _ from 'underscore'

class LSSettings {

    product = 'snippity'

    constructor({vm}, type, _meta) {
        this.data = null
        this.type = type
        this.vm = vm

        this.setmeta(_meta)

        this.getall().catch(e => {

        })

    }

    setmeta(_meta){
        this.meta = {}

        _.each(_meta[this.type], (s, k) => {
            this.setmetaOne(k,s)
        })
    }

    setmetaOne(k, s){
        console.log('setmetaOne', k, s)
        this.meta[k] = _.clone(s)
    }

    set(name, value) {

        var s = this.get(name)

        

        if (!s) {
            throw new Error('none')
        }

        if(!this.data[name]) this.data[name] = s

        s.value = value

        var dt = _.map(this.getbymeta(), (d) => {
            return {
                name: d.name,
                value: d.value
            }
        })


        localStorage.setItem('LSSettings_' + this.type, JSON.stringify(dt))

        this.setToStore()

        return Promise.resolve()
    }

    parse(r) {

        var d = {}

        try {
            r = JSON.parse(r)
        } catch (e) {
            console.error(e)
            return d
        }

        _.each(r, (r) => {

            if (!this.meta[r.name]) return

            try {

                var setting = {
                    name: r.name,
                    value: r.value,
                    default: this.meta[r.name].default(),
                }

                d[setting.name] = setting

            } catch (e) {
                console.error(e)
            }


        })

        return d
    }

    getbymeta() {
        var d = {}

        _.each(this.meta, (s, name) => {
            d[name] = this.get(name)
        })

        return d
    }

    get(name) {

        if (!this.data || !this.meta[name]) return null

        if (!this.data[name]) return {
            name: name,
            value: this.meta[name].default(),
            default: this.meta[name].default()
        }

        return this.data[name]
    }

    setToStore(){

        if(!this.vm) return

        var d = this.getbymeta()

        this.vm.$store.commit('lssettings', {
            type : this.type,
            data : d
        })
    }

    getall() {

        if (!this.data) this.data = this.parse(localStorage.getItem('LSSettings_' + this.type) || "{}")


        this.setToStore()

        return Promise.resolve(this.getbymeta())

    }

    clear(){
        this.data = null
    }

}

export {
    LSSettings
}